import { IGenerateAnswerState } from '../../common/reducers/types';
import { isAnswerGenerationEnabled } from '../../util/answerGenerationEnabled';
import { cleanGeneratedAnswer, countWords } from './index';

export enum SummarizedAnswerType {
  REGULAR = 'regular',
  PROHIBITED = 'prohibited',
  ANSWER_GENERATION_FAILED = 'answer generation failed',
}

export const getSummarizedAnswersGenFieldsBi = (answerGenResult: IGenerateAnswerState) => {
  if (!isAnswerGenerationEnabled()) {
    return {
      summarizedAnswerBasedOn: undefined,
      summarizedAnswerType: undefined as SummarizedAnswerType | undefined,
      summarizedAnswerText: undefined,
      summarizedAnswerWordsCount: undefined,
    };
  }

  let summarizedAnswerType: SummarizedAnswerType;
  if (answerGenResult.prohibited) {
    summarizedAnswerType = SummarizedAnswerType.PROHIBITED;
  } else if (answerGenResult.error || !answerGenResult.answer || answerGenResult.answer.length === 0) {
    summarizedAnswerType = SummarizedAnswerType.ANSWER_GENERATION_FAILED;
  } else if (answerGenResult.answer) {
    summarizedAnswerType = SummarizedAnswerType.REGULAR;
  } else {
    summarizedAnswerType = SummarizedAnswerType.REGULAR;
  }

  const getSummarizedAnswerBasedOn = () => {
    if (answerGenResult.usedArticlesInfo) {
      return Object.keys(answerGenResult.usedArticlesInfo).map((aritcleId) => ({
        article_id: aritcleId,
      }));
    }
  };

  return {
    summarizedAnswerBasedOn: JSON.stringify(getSummarizedAnswerBasedOn()),
    summarizedAnswerType,
    summarizedAnswerText: answerGenResult.answer ? cleanGeneratedAnswer(answerGenResult.answer) : undefined,
    summarizedAnswerWordsCount: countWords(answerGenResult.answer || ''),
    summarizedAnswerMediaDetails: answerGenResult.mediaRefsMap
      ? JSON.stringify(answerGenResult.mediaRefsMap)
      : undefined,
  };
};
